import { useTranslation } from 'next-i18next';
import { useFormatLargeNumber } from '@/hooks/number/useLargeNumber';
import { PlayIcon, QuestionmarkSmallBubbleIcon, SquareStackIcon } from '@/icons';
import { cn } from '@/utils';
import { type QuizListItemMetadataProps } from '../types/quiz-list-item.types';
export const QuizListItemMetadata = ({
  author,
  quizCount,
  playCount,
  copyCount,
  className,
  hideAuthorOnDesktop = false,
  hideCopyCountOnMobile = false
}: QuizListItemMetadataProps) => {
  return <div className={cn('flex w-full items-center gap-3xs', className)} data-sentry-component="QuizListItemMetadata" data-sentry-source-file="QuizListItemMetadata.tsx">
      {/* Author - shows on mobile, hidden on desktop if hideAuthorOnDesktop */}
      {author && <div className={cn('flex shrink-0 items-center gap-2xs', hideAuthorOnDesktop && 'tablet-lg:hidden')}>
          {author.avatar && <img src={author.avatar} alt={author.name} className="h-4 w-4 rounded-full" />}
          <span className="text-body-sm-medium text-alternative tablet-lg:text-body-md-medium">
            {author.name}
          </span>
        </div>}

      {/* Counters - right-aligned on mobile when author is present */}
      <div className={cn('flex items-center gap-xs tablet-lg:gap-md', author && hideAuthorOnDesktop ? 'flex-1 justify-end tablet-lg:flex-none tablet-lg:justify-start' : '')}>
        <QuizMetaInfo icon="quiz" count={quizCount} data-sentry-element="QuizMetaInfo" data-sentry-source-file="QuizListItemMetadata.tsx" />
        <QuizMetaInfo icon="play" count={playCount} data-sentry-element="QuizMetaInfo" data-sentry-source-file="QuizListItemMetadata.tsx" />
        {copyCount !== undefined && copyCount > 0 && <QuizMetaInfo icon="copy" count={copyCount} className={cn(hideCopyCountOnMobile && 'hidden tablet-lg:flex')} />}
      </div>
    </div>;
};
const QuizMetaInfo = ({
  icon,
  count,
  className
}: {
  icon: 'quiz' | 'play' | 'copy';
  count: number;
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const formatLargeNumber = useFormatLargeNumber();
  const postFix = icon === 'quiz' ? t('common:common.question') : '';
  const IconComponent = icon === 'quiz' ? QuestionmarkSmallBubbleIcon : icon === 'play' ? PlayIcon : SquareStackIcon;
  return <div className={cn('flex min-w-[32px] shrink-0 items-center gap-3xs text-body-sm-regular text-alternative', className)} data-sentry-component="QuizMetaInfo" data-sentry-source-file="QuizListItemMetadata.tsx">
      <IconComponent size="2xs" data-sentry-element="IconComponent" data-sentry-source-file="QuizListItemMetadata.tsx" />
      <span>
        {formatLargeNumber(count)}
        {postFix}
      </span>
    </div>;
};